import { GridLocaleText, deDE } from '@mui/x-data-grid-pro'
import React from 'react'

import i18n from '../../../../services/i18n'

export const useDataGridTranslation = (): Partial<GridLocaleText> => {
  const dataGridTranslations = React.useMemo<Partial<GridLocaleText>>(() => {
    return deDE.components.MuiDataGrid.defaultProps.localeText
  }, [i18n.language])

  return dataGridTranslations
}
